import { useSyncExternalStore } from "react";

let bust = Date.now();
const listeners = new Set<() => void>();

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const bumpMediaBust = () => {
  bust = Date.now();
  listeners.forEach((listener) => listener());
};

export const getMediaBust = () => bust;

export const useMediaBust = () =>
  useSyncExternalStore(subscribe, getMediaBust, getMediaBust);

export const withCacheBust = (url: string, token: number) => {
  if (!url || url.startsWith("blob:")) return url;
  return `${url.split("?")[0]}?t=${token}`;
};
